import React, { useState, useEffect } from 'react';
import { authService } from '../../api';
import { useNavigate } from 'react-router-dom';
import './UserUpdateprofil.css';
import ImageCropper from '../../components/UserSpace/ImageCropper';
import { FaCrop } from 'react-icons/fa';
import {
    FaArrowLeft,
    FaSave,
    FaCamera,
    FaTrash,
    FaUser,
    FaEnvelope,
    FaPhone,
    FaMapMarkerAlt,
    FaLinkedin,
    FaGlobe,
    FaEuroSign,
    FaGraduationCap,
    FaBriefcase,
    FaIndustry,
    FaCalendarAlt,
    FaLightbulb,
    FaHandsHelping,
    FaPlus,
    FaTimes,
    FaExclamationTriangle
} from 'react-icons/fa';

const UserUpdateprofil = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    
    const [imageFile, setImageFile] = useState(null);
    const [existingImage, setExistingImage] = useState(null);
    const [imageRemoved, setImageRemoved] = useState(false);
    const [showCropper, setShowCropper] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        role: '',
        ville: '',
        bio: '',
        telephone: '',
        prenom: '',
        linkedin: '',
        site_internet: '',
        tarif: 'gratuit',
        prix: '',
        region_couverte: '',
        services: [],
        modes_accompagnement: [],
        siret: '',
        secteur_activite: '',
        nom_entreprise: '',
        niveau_etude: '',
        specialite_etudes: '',
        secteur_pro: '',
        annee_arrivee_fr: '',
        besoins: [],
        password: '',
        password_confirmation: ''
    });
    
    const [newService, setNewService] = useState('');
    const [newMode, setNewMode] = useState('');
    const [newBesoins, setNewBesoins] = useState('');

    const tarifOptions = [
        { value: 'gratuit', label: 'Gratuit' },
        { value: 'payant', label: 'Payant' },
        { value: 'les deux', label: 'Les deux' }
    ];

    const niveauEtudeOptions = [
        'Bac', 'Bac+2', 'Bac+3', 'Bac+4', 'Bac+5', 'Doctorat'
    ];

    const secteurOptions = [
        'Informatique', 'Marketing', 'Finance', 'Ressources Humaines',
        'Commerce', 'Industrie', 'Santé', 'Éducation', 'Autre'
    ];

    useEffect(() => {
        fetchUserData();
    }, []);


    const handleCropComplete = (croppedBlob) => {
    if (croppedBlob) {
        // Créer un fichier à partir du blob
        const fileName = `cropped-${Date.now()}.jpg`;
        const croppedFile = new File([croppedBlob], fileName, {
            type: 'image/jpeg',
            lastModified: Date.now()
        });
        
        // Mettre à jour le fichier image
        setImageFile(croppedFile);
        setImageRemoved(false);
        
        // Nettoyer l'ancienne URL si elle existe
        if (croppedImage) {
            URL.revokeObjectURL(croppedImage);
        }
        
        // Créer une nouvelle URL pour l'aperçu
        const objectUrl = URL.createObjectURL(croppedBlob);
        setCroppedImage(objectUrl);
    }
    
    setShowCropper(false);
    setImageToCrop(null);
};

    const fetchUserData = async () => {
        try {
            const user = await authService.getProfile();
            
            if (user.image_url) {
                setExistingImage(user.image_url);
            }
            
            // CORRECTION : S'assurer que les tableaux sont bien des tableaux
            const services = user.services ? 
                (Array.isArray(user.services) ? user.services : 
                (typeof user.services === 'string' ? JSON.parse(user.services || '[]') : [])) : [];
            
            const modes_accompagnement = user.modes_accompagnement ? 
                (Array.isArray(user.modes_accompagnement) ? user.modes_accompagnement : 
                (typeof user.modes_accompagnement === 'string' ? JSON.parse(user.modes_accompagnement || '[]') : [])) : [];
            
            const besoins = user.besoins ? 
                (Array.isArray(user.besoins) ? user.besoins : 
                (typeof user.besoins === 'string' ? JSON.parse(user.besoins || '[]') : [])) : [];
            
            setUserData({
                name: user.name || '',
                email: user.email || '',
                role: user.role || '',
                ville: user.ville || '',
                bio: user.bio || '',
                telephone: user.telephone || '',
                prenom: user.prenom || '',
                linkedin: user.linkedin || '',
                site_internet: user.site_internet || '',
                tarif: user.tarif || 'gratuit',
                prix: user.prix || '',
                region_couverte: user.region_couverte || '',
                services: services,
                modes_accompagnement: modes_accompagnement,
                siret: user.siret || '',
                secteur_activite: user.secteur_activite || '',
                nom_entreprise: user.nom_entreprise || user.name || '',
                niveau_etude: user.niveau_etude || '',
                specialite_etudes: user.specialite_etudes || '',
                secteur_pro: user.secteur_pro || '',
                annee_arrivee_fr: user.annee_arrivee_fr || '',
                besoins: besoins,
                password: '',
                password_confirmation: ''
            });
            
            setLoading(false);
        } catch (error) {
            console.error('Erreur lors du chargement des données:', error);
            setErrors({ general: 'Impossible de charger les données du profil' });
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        setUserData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

const handleImageChange = (e) => {
    const file = e.target.files[0];
    
    if (file) {
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
        const maxSize = 2 * 1024 * 1024;
        
        if (!validTypes.includes(file.type)) {
            setErrors(prev => ({
                ...prev,
                image: 'Format d\'image non valide. Utilisez JPG, PNG ou GIF.'
            }));
            return;
        }
        
        if (file.size > maxSize) {
            setErrors(prev => ({
                ...prev,
                image: 'L\'image est trop volumineuse. Taille maximum : 2MB.'
            }));
            return;
        }
        
        // Afficher le rogneur d'image au lieu de l'assigner directement
        const reader = new FileReader();
        reader.onloadend = () => {
            setImageToCrop(reader.result);
            setShowCropper(true);
        };
        reader.readAsDataURL(file);
        
        if (errors.image) {
            setErrors(prev => ({ ...prev, image: null }));
        }
    }
};

// Ajoutez cette fonction si elle n'existe pas, sinon modifiez-là
const handleCancel = () => {
    // Nettoyer les URLs d'objets si nécessaire
    if (croppedImage) {
        URL.revokeObjectURL(croppedImage);
    }
    navigate('/mon-compte');
};
  const removeImage = () => {
    setImageFile(null);
    setExistingImage(null);
    setImageRemoved(true);
    
    // Nettoyer l'URL de l'objet si une image a été rognée
    if (croppedImage) {
        URL.revokeObjectURL(croppedImage);
        setCroppedImage(null);
    }
};

    const addService = () => {
        if (newService.trim() && !userData.services.includes(newService.trim())) {
            setUserData(prev => ({
                ...prev,
                services: [...prev.services, newService.trim()]
            }));
            setNewService('');
        }
    };

    const removeService = (index) => {
        setUserData(prev => ({
            ...prev,
            services: prev.services.filter((_, i) => i !== index)
        }));
    };

    const addMode = () => {
        if (newMode.trim() && !userData.modes_accompagnement.includes(newMode.trim())) {
            setUserData(prev => ({
                ...prev,
                modes_accompagnement: [...prev.modes_accompagnement, newMode.trim()]
            }));
            setNewMode('');
        }
    };

    const removeMode = (index) => {
        setUserData(prev => ({
            ...prev,
            modes_accompagnement: prev.modes_accompagnement.filter((_, i) => i !== index)
        }));
    };

    const addBesoin = () => {
        if (newBesoins.trim() && !userData.besoins.includes(newBesoins.trim())) {
            setUserData(prev => ({
                ...prev,
                besoins: [...prev.besoins, newBesoins.trim()]
            }));
            setNewBesoins('');
        }
    };

    const removeBesoin = (index) => {
        setUserData(prev => ({
            ...prev,
            besoins: prev.besoins.filter((_, i) => i !== index)
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        
        // Validation selon le rôle
        if (userData.role === 'entreprise') {
            if (!userData.nom_entreprise?.trim()) {
                newErrors.nom_entreprise = 'Le nom de l\'entreprise est requis';
            }
            
            // Validation SIRET
            if (userData.siret && !/^\d{14}$/.test(userData.siret.replace(/\s/g, ''))) {
                newErrors.siret = 'Le SIRET doit comporter 14 chiffres';
            }
        } else {
            if (!userData.name?.trim()) {
                newErrors.name = 'Le nom est requis';
            }
        }
        
        // Validation téléphone
        if (userData.telephone && !/^[0-9+\s\-()]{10,20}$/.test(userData.telephone)) {
            newErrors.telephone = 'Numéro de téléphone invalide';
        }
        
        // Validation tarif et prix
        if (userData.tarif === 'payant' || userData.tarif === 'les deux') {
            if (userData.prix && (isNaN(userData.prix) || parseFloat(userData.prix) < 0)) {
                newErrors.prix = 'Le prix doit être un nombre positif';
            }
        }
        
        // Validation mot de passe
        if (userData.password) {
            if (userData.password.length < 6) {
                newErrors.password = 'Le mot de passe doit contenir au moins 6 caractères';
            }
            if (userData.password !== userData.password_confirmation) {
                newErrors.password_confirmation = 'Les mots de passe ne correspondent pas';
            }
        }
        
        // Validation année arrivée France
        if (userData.role === 'mentor' && userData.annee_arrivee_fr) {
            const currentYear = new Date().getFullYear();
            if (userData.annee_arrivee_fr < 1950 || userData.annee_arrivee_fr > currentYear) {
                newErrors.annee_arrivee_fr = `L'année doit être comprise entre 1950 et ${currentYear}`;
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
        return;
    }
    
    setSaving(true);
    setErrors({});
    setSuccessMessage('');
    
    try {
        const formData = new FormData();
        
        // CORRECTION CRITIQUE : Envoyer les données selon les règles de validation du backend
        
        // 1. Champs textuels simples
        const textFields = [
            'name', 'ville', 'bio', 'telephone', 'prenom', 'linkedin', 
            'site_internet', 'tarif', 'prix', 'region_couverte', 'siret',
            'secteur_activite', 'nom_entreprise', 'niveau_etude',
            'specialite_etudes', 'secteur_pro', 'annee_arrivee_fr'
        ];
        
        textFields.forEach(field => {
            if (userData[field] !== undefined && userData[field] !== null) {
                const value = userData[field] === '' ? '' : userData[field];
                formData.append(field, value);
            }
        });
        
        // 2. Tableaux
        // Services
        if (userData.services && userData.services.length > 0) {
            userData.services.forEach((service, index) => {
                formData.append(`services[${index}]`, service);
            });
        } else {
            formData.append('services', '[]');
        }
        
        // Modes d'accompagnement
        if (userData.modes_accompagnement && userData.modes_accompagnement.length > 0) {
            userData.modes_accompagnement.forEach((mode, index) => {
                formData.append(`modes_accompagnement[${index}]`, mode);
            });
        } else {
            formData.append('modes_accompagnement', '[]');
        }
        
        // Besoins
        if (userData.besoins && userData.besoins.length > 0) {
            userData.besoins.forEach((besoin, index) => {
                formData.append(`besoins[${index}]`, besoin);
            });
        } else {
            formData.append('besoins', '[]');
        }
        
        // 3. Mot de passe (seulement si fourni)
        if (userData.password && userData.password.trim() !== '') {
            formData.append('password', userData.password);
            formData.append('password_confirmation', userData.password_confirmation);
        }
        
        // 4. CORRECTION CRITIQUE : Gestion de l'image - SIMPLIFIÉE
        // Trois cas possibles :
        // 1. Nouvelle image sélectionnée → envoyer le fichier
        // 2. Image supprimée → envoyer une chaîne vide
        // 3. Pas de changement → ne rien envoyer du tout pour le champ image
        
             // 4. ⭐⭐ GESTION DE L'IMAGE - EXACTEMENT comme dans UserUpdateannonce ⭐⭐
        if (imageFile instanceof File) {
            // CAS A: Nouvelle image sélectionnée
            formData.append('image', imageFile);
            console.log('📸 Envoi nouvelle image:', imageFile.name);
        } else if (imageRemoved) {
            // CAS B: Image supprimée - EXACTEMENT comme dans annonces
            formData.append('image', ''); // Chaîne vide
            console.log('🗑️ Envoi chaîne vide pour suppression');
        }
        // CAS C: Garder l'image existante → NE RIEN FAIRE (pas de champ image)
        
        // 5. _method PUT - EXACTEMENT comme dans annonces
        formData.append('_method', 'PUT');
        
        // 6. Correction pour le nom selon le rôle
        if (userData.role === 'entreprise') {
            formData.set('name', userData.nom_entreprise);
        }
        
        // Debug: Afficher les données envoyées
        console.log('=== DONNÉES ENVOYÉES CORRIGÉES ===');
        console.log('Image file:', imageFile ? `Fichier (${imageFile.name})` : 'Aucun');
        console.log('Image removed:', imageRemoved);
        console.log('Existing image:', existingImage ? 'Existe' : 'Aucune');

        console.log('=== DONNÉES FORMDATA ===');
for (let [key, value] of formData.entries()) {
    console.log(`${key}:`, value instanceof File ? `FILE: ${value.name} (${value.size} bytes)` : value);
}
        
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value instanceof File ? `Fichier (${value.name}, ${value.size} bytes)` : value);
        }
        
        // Envoyer la requête
        const response = await authService.updateProfile(formData);
        
        // Mettre à jour l'image si nécessaire
        if (response.data && response.data.image_url) {
            setExistingImage(response.data.image_url);
            setImageRemoved(false);
        } else if (imageRemoved) {
            // Si l'image a été supprimée avec succès
            setExistingImage(null);
        }
        
        // Réinitialiser le fichier image après succès
        setImageFile(null);
        
        setSuccessMessage(response.message || 'Profil mis à jour avec succès');
        
        // Rediriger après un délai
        setTimeout(() => {
            navigate('/mon-compte');
        }, 2000);
        
    } catch (error) {
        console.error('Erreur lors de la mise à jour:', error);
        
        // Afficher les erreurs de validation
        if (error.code === 'VALIDATION_ERROR' && error.errors) {
            const formattedErrors = {};
            Object.keys(error.errors).forEach(key => {
                if (Array.isArray(error.errors[key]) && error.errors[key].length > 0) {
                    formattedErrors[key] = error.errors[key][0];
                } else {
                    formattedErrors[key] = error.errors[key];
                }
            });
            setErrors(formattedErrors);
        } else if (error.response?.data?.errors) {
            const formattedErrors = {};
            Object.keys(error.response.data.errors).forEach(key => {
                if (Array.isArray(error.response.data.errors[key]) && error.response.data.errors[key].length > 0) {
                    formattedErrors[key] = error.response.data.errors[key][0];
                } else {
                    formattedErrors[key] = error.response.data.errors[key];
                }
            });
            setErrors(formattedErrors);
        } else {
            setErrors({ 
                general: error.message || 'Une erreur est survenue lors de la mise à jour'
            });
        }
    } finally {
        setSaving(false);
    }
};

    const renderRoleSpecificFields = () => {
        switch (userData.role) {
            case 'expert':
                return (
                    <div className="role-section">
                        <h3><FaUser /> Informations Expert</h3>
                        
                        <div className="form-group">
                            <label>Prénom *</label>
                            <input
                                type="text"
                                name="prenom"
                                value={userData.prenom}
                                onChange={handleInputChange}
                                className={errors.prenom ? 'error' : ''}
                            />
                            {errors.prenom && <span className="error-message">{errors.prenom}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Tarif *</label>
                            <select
                                name="tarif"
                                value={userData.tarif}
                                onChange={handleInputChange}
                                className={errors.tarif ? 'error' : ''}
                            >
                                {tarifOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {errors.tarif && <span className="error-message">{errors.tarif}</span>}
                        </div>
                        
                        {(userData.tarif === 'payant' || userData.tarif === 'les deux') && (
                            <div className="form-group">
                                <label>Prix (€)</label>
                                <input
                                    type="number"
                                    name="prix"
                                    value={userData.prix}
                                    onChange={handleInputChange}
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    className={errors.prix ? 'error' : ''}
                                />
                                {errors.prix && <span className="error-message">{errors.prix}</span>}
                            </div>
                        )}
                        
                        <div className="form-group">
                            <label>Région couverte</label>
                            <input
                                type="text"
                                name="region_couverte"
                                value={userData.region_couverte}
                                onChange={handleInputChange}
                                placeholder="ex: Île-de-France, Auvergne-Rhône-Alpes..."
                            />
                        </div>
                        
                        <div className="form-group">
                            <label>Services *</label>
                            <div className="tags-input">
                                <div className="tags-container">
                                    {userData.services.map((service, index) => (
                                        <span key={index} className="tag">
                                            {service}
                                            <button type="button" onClick={() => removeService(index)}>
                                                <FaTimes />
                                            </button>
                                        </span>
                                    ))}
                                </div>
                                <div className="tag-input">
                                    <input
                                        type="text"
                                        value={newService}
                                        onChange={(e) => setNewService(e.target.value)}
                                        placeholder="Ajouter un service..."
                                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addService())}
                                    />
                                    <button type="button" onClick={addService} className="add-tag-btn">
                                        <FaPlus />
                                    </button>
                                </div>
                                {errors.services && <span className="error-message">{errors.services}</span>}
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label>Modes d'accompagnement *</label>
                            <div className="tags-input">
                                <div className="tags-container">
                                    {userData.modes_accompagnement.map((mode, index) => (
                                        <span key={index} className="tag">
                                            {mode}
                                            <button type="button" onClick={() => removeMode(index)}>
                                                <FaTimes />
                                            </button>
                                        </span>
                                    ))}
                                </div>
                                <div className="tag-input">
                                    <input
                                        type="text"
                                        value={newMode}
                                        onChange={(e) => setNewMode(e.target.value)}
                                        placeholder="Ajouter un mode d'accompagnement..."
                                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addMode())}
                                    />
                                    <button type="button" onClick={addMode} className="add-tag-btn">
                                        <FaPlus />
                                    </button>
                                </div>
                                {errors.modes_accompagnement && <span className="error-message">{errors.modes_accompagnement}</span>}
                            </div>
                        </div>
                    </div>
                );
            
            case 'entreprise':
                return (
                    <div className="role-section">
                        <h3><FaBriefcase /> Informations Entreprise</h3>
                        
                        <div className="form-group">
                            <label>Nom de l'entreprise *</label>
                            <input
                                type="text"
                                name="nom_entreprise"
                                value={userData.nom_entreprise}
                                onChange={handleInputChange}
                                className={errors.nom_entreprise ? 'error' : ''}
                            />
                            {errors.nom_entreprise && <span className="error-message">{errors.nom_entreprise}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>SIRET</label>
                            <input
                                type="text"
                                name="siret"
                                value={userData.siret}
                                onChange={handleInputChange}
                                placeholder="14 chiffres"
                                className={errors.siret ? 'error' : ''}
                            />
                            {errors.siret && <span className="error-message">{errors.siret}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Secteur d'activité *</label>
                            <select
                                name="secteur_activite"
                                value={userData.secteur_activite}
                                onChange={handleInputChange}
                                className={errors.secteur_activite ? 'error' : ''}
                            >
                                <option value="">Sélectionnez un secteur</option>
                                {secteurOptions.map(secteur => (
                                    <option key={secteur} value={secteur}>{secteur}</option>
                                ))}
                            </select>
                            {errors.secteur_activite && <span className="error-message">{errors.secteur_activite}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Services *</label>
                            <div className="tags-input">
                                <div className="tags-container">
                                    {userData.services.map((service, index) => (
                                        <span key={index} className="tag">
                                            {service}
                                            <button type="button" onClick={() => removeService(index)}>
                                                <FaTimes />
                                            </button>
                                        </span>
                                    ))}
                                </div>
                                <div className="tag-input">
                                    <input
                                        type="text"
                                        value={newService}
                                        onChange={(e) => setNewService(e.target.value)}
                                        placeholder="Ajouter un service..."
                                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addService())}
                                    />
                                    <button type="button" onClick={addService} className="add-tag-btn">
                                        <FaPlus />
                                    </button>
                                </div>
                                {errors.services && <span className="error-message">{errors.services}</span>}
                            </div>
                        </div>
                    </div>
                );
            
            case 'etudiant':
                return (
                    <div className="role-section">
                        <h3><FaGraduationCap /> Informations Étudiant</h3>
                        
                        <div className="form-group">
                            <label>Prénom *</label>
                            <input
                                type="text"
                                name="prenom"
                                value={userData.prenom}
                                onChange={handleInputChange}
                                className={errors.prenom ? 'error' : ''}
                            />
                            {errors.prenom && <span className="error-message">{errors.prenom}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Niveau d'étude</label>
                            <select
                                name="niveau_etude"
                                value={userData.niveau_etude}
                                onChange={handleInputChange}
                                className={errors.niveau_etude ? 'error' : ''}
                            >
                                <option value="">Sélectionnez un niveau</option>
                                {niveauEtudeOptions.map(niveau => (
                                    <option key={niveau} value={niveau}>{niveau}</option>
                                ))}
                            </select>
                            {errors.niveau_etude && <span className="error-message">{errors.niveau_etude}</span>}
                        </div>
                    </div>
                );
            
            case 'mentor':
                return (
                    <div className="role-section">
                        <h3><FaHandsHelping /> Informations Mentor</h3>
                        
                        <div className="form-group">
                            <label>Prénom *</label>
                            <input
                                type="text"
                                name="prenom"
                                value={userData.prenom}
                                onChange={handleInputChange}
                                className={errors.prenom ? 'error' : ''}
                            />
                            {errors.prenom && <span className="error-message">{errors.prenom}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Spécialité d'études *</label>
                            <input
                                type="text"
                                name="specialite_etudes"
                                value={userData.specialite_etudes}
                                onChange={handleInputChange}
                                placeholder="ex: Informatique, Marketing..."
                                className={errors.specialite_etudes ? 'error' : ''}
                            />
                            {errors.specialite_etudes && <span className="error-message">{errors.specialite_etudes}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Secteur professionnel *</label>
                            <input
                                type="text"
                                name="secteur_pro"
                                value={userData.secteur_pro}
                                onChange={handleInputChange}
                                placeholder="ex: Tech, Finance..."
                                className={errors.secteur_pro ? 'error' : ''}
                            />
                            {errors.secteur_pro && <span className="error-message">{errors.secteur_pro}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Année d'arrivée en France</label>
                            <input
                                type="number"
                                name="annee_arrivee_fr"
                                value={userData.annee_arrivee_fr}
                                onChange={handleInputChange}
                                min="1950"
                                max={new Date().getFullYear()}
                                className={errors.annee_arrivee_fr ? 'error' : ''}
                            />
                            {errors.annee_arrivee_fr && <span className="error-message">{errors.annee_arrivee_fr}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Région couverte</label>
                            <input
                                type="text"
                                name="region_couverte"
                                value={userData.region_couverte}
                                onChange={handleInputChange}
                                placeholder="ex: Île-de-France..."
                            />
                        </div>
                        
                        <div className="form-group">
                            <label>Services *</label>
                            <div className="tags-input">
                                <div className="tags-container">
                                    {userData.services.map((service, index) => (
                                        <span key={index} className="tag">
                                            {service}
                                            <button type="button" onClick={() => removeService(index)}>
                                                <FaTimes />
                                            </button>
                                        </span>
                                    ))}
                                </div>
                                <div className="tag-input">
                                    <input
                                        type="text"
                                        value={newService}
                                        onChange={(e) => setNewService(e.target.value)}
                                        placeholder="Ajouter un service..."
                                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addService())}
                                    />
                                    <button type="button" onClick={addService} className="add-tag-btn">
                                        <FaPlus />
                                    </button>
                                </div>
                                {errors.services && <span className="error-message">{errors.services}</span>}
                            </div>
                        </div>
                    </div>
                );
            
            default:
                return null;
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Chargement des données du profil...</p>
            </div>
        );
    }

    return (
        <div className="update-profile-container">

            {showCropper && (
            <div className="modal-overlay">
                <ImageCropper
                    image={imageToCrop}
                    onCropComplete={handleCropComplete}
                    aspectRatio={1/1} // Ratio carré pour les photos de profil
                />
            </div>
        )}
            <div className="update-profile-header">
                <button className="back-btn" onClick={() => navigate('/mon-compte')}>
                    <FaArrowLeft /> Retour
                </button>
                <h1>Modifier mon profil</h1>
                <span className="role-badge">{userData.role}</span>
            </div>

            {errors.general && (
                <div className="alert alert-error">
                    <FaExclamationTriangle /> {errors.general}
                </div>
            )}

            {successMessage && (
                <div className="alert alert-success">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="update-profile-form">
                <div className="form-section">
                    <h2><FaCamera /> Photo de profil</h2>
                    
                    <div className="image-upload-section">
         <div className="image-preview-container">
    {existingImage || imageFile ? (
        <div className="image-preview">
            <img 
                src={croppedImage || (imageFile ? URL.createObjectURL(imageFile) : existingImage)} 
                alt="Profil" 
            />
            <div className="image-actions">
                <button 
                    type="button" 
                    className="remove-image-btn"
                    onClick={removeImage}
                >
                    <FaTrash />
                </button>
                <button 
                    type="button" 
                    className="crop-image-btn"
                    onClick={() => {
                        if (imageFile) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                setImageToCrop(reader.result);
                                setShowCropper(true);
                            };
                            reader.readAsDataURL(imageFile);
                        } else if (existingImage) {
                            setImageToCrop(existingImage);
                            setShowCropper(true);
                        }
                    }}
                >
                    <FaCrop /> Rogner
                </button>
            </div>
        </div>
    ) : (
        <div className="image-placeholder">
            <FaUser size={40} />
            <p>Aucune photo</p>
        </div>
    )}
</div>
                        
                        <div className="image-upload-controls">
                            <label className="file-upload-btn">
                                <input
                                    type="file"
                                    accept="image/jpeg,image/png,image/jpg,image/gif"
                                    onChange={handleImageChange}
                                    style={{ display: 'none' }}
                                />
                                <FaCamera /> Choisir une photo
                            </label>
<p className="file-info">
    Formats acceptés : JPG, PNG, GIF. Taille max : 2MB
    <br />
    <small>Vous pourrez rogner l'image après sélection</small>
</p>
                            {errors.image && <span className="error-message">{errors.image}</span>}
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <h2><FaUser /> Informations de base</h2>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label>
                                {userData.role === 'entreprise' ? 'Nom de l\'entreprise *' : 'Nom *'}
                            </label>
                            <input
                                type="text"
                                name={userData.role === 'entreprise' ? 'nom_entreprise' : 'name'}
                                value={userData.role === 'entreprise' ? userData.nom_entreprise : userData.name}
                                onChange={handleInputChange}
                                className={errors.name || errors.nom_entreprise ? 'error' : ''}
                            />
                            {errors.name && <span className="error-message">{errors.name}</span>}
                            {errors.nom_entreprise && <span className="error-message">{errors.nom_entreprise}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                value={userData.email}
                                disabled
                                className="disabled-input"
                            />
                            <small className="hint">L'email ne peut pas être modifié</small>
                        </div>
                    </div>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label>Téléphone</label>
                            <input
                                type="text"
                                name="telephone"
                                value={userData.telephone}
                                onChange={handleInputChange}
                                placeholder="ex: +33 1 23 45 67 89"
                                className={errors.telephone ? 'error' : ''}
                            />
                            {errors.telephone && <span className="error-message">{errors.telephone}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Ville</label>
                            <input
                                type="text"
                                name="ville"
                                value={userData.ville}
                                onChange={handleInputChange}
                                placeholder="ex: Paris"
                                className={errors.ville ? 'error' : ''}
                            />
                            {errors.ville && <span className="error-message">{errors.ville}</span>}
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label>Biographie</label>
                        <textarea
                            name="bio"
                            value={userData.bio}
                            onChange={handleInputChange}
                            rows="4"
                            placeholder="Décrivez-vous ou présentez votre activité..."
                            className={errors.bio ? 'error' : ''}
                        />
                        {errors.bio && <span className="error-message">{errors.bio}</span>}
                    </div>
                </div>

                {renderRoleSpecificFields()}

                {userData.role !== 'entreprise' && (
                    <div className="form-section">
                        <h3><FaLightbulb /> Mes besoins</h3>
                        <div className="form-group">
                            <div className="tags-input">
                                <div className="tags-container">
                                    {userData.besoins.map((besoin, index) => (
                                        <span key={index} className="tag">
                                            {besoin}
                                            <button type="button" onClick={() => removeBesoin(index)}>
                                                <FaTimes />
                                            </button>
                                        </span>
                                    ))}
                                </div>
                                <div className="tag-input">
                                    <input
                                        type="text"
                                        value={newBesoins}
                                        onChange={(e) => setNewBesoins(e.target.value)}
                                        placeholder="Ajouter un besoin..."
                                        onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addBesoin())}
                                    />
                                    <button type="button" onClick={addBesoin} className="add-tag-btn">
                                        <FaPlus />
                                    </button>
                                </div>
                                {errors.besoins && <span className="error-message">{errors.besoins}</span>}
                            </div>
                            <small className="hint">
                                Exemples : accompagnement, conseil, réseau, formation...
                            </small>
                        </div>
                    </div>
                )}

                <div className="form-section">
                    <h3><FaGlobe /> Liens externes</h3>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label>LinkedIn</label>
                            <input
                                type="url"
                                name="linkedin"
                                value={userData.linkedin}
                                onChange={handleInputChange}
                                placeholder="https://linkedin.com/in/votre-profil"
                                className={errors.linkedin ? 'error' : ''}
                            />
                            {errors.linkedin && <span className="error-message">{errors.linkedin}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Site web</label>
                            <input
                                type="url"
                                name="site_internet"
                                value={userData.site_internet}
                                onChange={handleInputChange}
                                placeholder="https://votre-site.com"
                                className={errors.site_internet ? 'error' : ''}
                            />
                            {errors.site_internet && <span className="error-message">{errors.site_internet}</span>}
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <h3><FaUser /> Modifier le mot de passe</h3>
                    <p className="section-description">
                        Laissez vide si vous ne souhaitez pas modifier votre mot de passe
                    </p>
                    
                    <div className="form-row">
                        <div className="form-group">
                            <label>Nouveau mot de passe</label>
                            <input
                                type="password"
                                name="password"
                                value={userData.password}
                                onChange={handleInputChange}
                                className={errors.password ? 'error' : ''}
                            />
                            {errors.password && <span className="error-message">{errors.password}</span>}
                        </div>
                        
                        <div className="form-group">
                            <label>Confirmer le mot de passe</label>
                            <input
                                type="password"
                                name="password_confirmation"
                                value={userData.password_confirmation}
                                onChange={handleInputChange}
                                className={errors.password_confirmation ? 'error' : ''}
                            />
                            {errors.password_confirmation && (
                                <span className="error-message">{errors.password_confirmation}</span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        className="cancel-btn"
                        onClick={() => navigate('/mon-compte')}
                        disabled={saving}
                    >
                        Annuler
                    </button>
                    
                    <button
                        type="submit"
                        className="save-btn"
                        disabled={saving}
                    >
                        {saving ? (
                            <>
                                <div className="spinner-small"></div>
                                Enregistrement...
                            </>
                        ) : (
                            <>
                                <FaSave /> Enregistrer les modifications
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UserUpdateprofil;